export default "<app-collaborators-list></app-collaborators-list>";